// DS: IL5.7
import React from 'react';
const BoostIllustration = ({ size = 96 })=>{
    return /*#__PURE__*/ React.createElement("img", {
        width: size,
        src: "//st.deviantart.net/eclipse/illustrations/boost-deviation.png",
        alt: "rocket flying in space"
    });
};
BoostIllustration.displayName = 'BoostIllustration';
export default BoostIllustration;

//# sourceMappingURL=BoostIllustration.js.map